import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31499 21952"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m20228 21554 10724-9376c729-637 729-1768 0-2404L20228 398c-1033-902-2648-169-2648 1202v18752c0 1371 1615 2104 2648 1202z"
        className="fil0"
      />
      <g id="_1970276461296">
        <path
          d="M13606 3480c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-506 1128-1128c0-624-505-1128-1128-1128zM13606 7725c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128z"
          className="fil0"
        />
        <circle cx={13606} cy={13098} r={1128} className="fil0" />
        <path
          d="M13606 16216c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128z"
          className="fil0"
        />
      </g>
      <g id="_1970276460880">
        <path
          d="M9447 3480c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-506 1128-1128c0-624-505-1128-1128-1128zM9447 7725c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128zM9447 11970c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128zM9447 16216c-623 0-1128 505-1128 1128s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128z"
          className="fil0"
        />
      </g>
      <g id="_1970276447248">
        <path
          d="M5288 7725c-624 0-1129 505-1129 1128s505 1128 1129 1128c623 0 1128-505 1128-1128s-506-1128-1128-1128zM5288 11970c-624 0-1129 505-1129 1128s505 1128 1129 1128c623 0 1128-505 1128-1128s-506-1128-1128-1128z"
          className="fil0"
        />
      </g>
      <g id="_1970276447568">
        <path
          d="M1128 7725C505 7725 0 8230 0 8853s505 1128 1128 1128 1128-505 1128-1128-505-1128-1128-1128z"
          className="fil0"
        />
        <circle cx={1128} cy={13098} r={1128} className="fil0" />
      </g>
    </g>
  </svg>
)
export default SvgComponent
